<template>
  <div class="interface-area invest">
    <WindowModal :title="modalTitle" type="Global" :visible="true">
      <template #modal-content>
        <InvestToken
          :method="method"
          :balance="user !== null ? user.dfp_balance : 0"
          :price="price"
          @initSuccess="showSuccessMessage"
          @closeGlobalModal="closeModal"
        />
      </template>
    </WindowModal>
    <div class="transaction-box invest-block">
      <div class="left-area">
        <div class="level-area">
          <div class="level-icon">
            <div class="current-level" :style="{background: currentLevel !== null ? currentLevel.color : 'linear-gradient(215deg, #2B18FF 19.48%, #34AEFE 95.82%)'}">
              <div class="first-gradient"></div>
              <div class="second-gradient"></div>
            </div>
          </div>
          <div class="text-area">
            <div v-if="user !== null" class="h1">
              {{ $t('invest.your_level_is') }}
              {{ currentLevel !== null ? currentLevel.name : '...' }}
            </div>
            <div v-else class="h1">
              {{ $t('invest.login_to_benefit') }}
            </div>
            <div class="desc">
              {{ $t('invest.level_desc') }}
            </div>
          </div>
        </div>
        <div v-if="user !== null" class="level-info">
          <div class="text-info">
            <p class="paragraph">
              {{ $t('invest.bonus_tokens') }}
              <span class="colored">
                {{ currentLevel !== null ? $priceFormat(currentLevel.discount, 1) : '...' }}%
              </span>
            </p>
            <p v-if="nextLevel !== null && currentLevel !== null" class="paragraph smaller">
              {{ $t('invest.more_tokens', { tokens: nextLevel.from - user.dfp_balance }) }}
              <span class="colored">
                {{ nextLevel.name }}
              </span>
              {{ $t('invest.level') }}.
            </p>
          </div>
          <div class="action-buttons">
            <!-- <button v-if="user !== undefined && user !== null" type="button" class="btn cyan" @click="openBuyModal"> -->
            <button v-if="user !== undefined && user !== null" type="button" class="btn cyan" @click="googleform">  
              {{ $t('invest.buy_dfp') }}
            </button>
            <button v-else type="button" class="btn cyan" @click="openConnectModal">
              {{ $t('common.connect_wallet') }}
            </button>
          </div>
        </div>
        <div class="divider"></div>
        <div class="stats">
          <div class="stat">
            <div class="label">
              {{ $t('invest.price') }}
            </div>
            <div class="value">
              {{ price }} USDT
            </div>
          </div>
          <div class="stat">
            <div class="label">
              {{ $t('invest.total_suply') }}
            </div>
            <div class="value">
              {{ $priceFormat(totalSupply, 0) }}
            </div>
          </div>
          <div class="stat">
            <div class="label">
              {{ $t('invest.blockchain') }}
            </div>
            <div class="value">
              Binance Smart Chain (BSC)
            </div>
          </div>
        </div>
      </div>
      <div class="divider horizontal"></div>
      <div class="right-area">
        <div class="balance-area">
          <h1 class="title">
            {{ $t('invest.invest') }}
          </h1>
          <div class="divider"></div>
          <div class="balance-info">
            <div class="balance">
              <div class="label">
                {{ $t('invest.my_balance') }}
              </div>
              <div class="numbers">
                <picture>
                  <source srcset="/img/new/floatie-token.webp" type="image/webp">
                  <nuxt-img
                    fit="inside"
                    src="/img/new/floatie-token.png"
                    alt="Buy Defi Pool token (DFP) to get rewards, discounts and better staking/farming percent"
                    title="Buy $DFP token"
                    loading="lazy"
                    placeholder
                    :quality="80"
                  />
                </picture>
                {{ user !== null ? $priceFormat(user.dfp_balance, 0) : '0' }} DFP
              </div>
              <div class="usd-convert">
                ~ ${{ user !== null ? $priceFormat(user.dfp_balance * price, 2) : '0' }}
              </div>
            </div>
            <div class="action-buttons">
              <!-- <button v-if="user !== undefined && user !== null" type="button" class="btn pink smaller" @click="openBuyModal"> -->
              <button v-if="user !== undefined && user !== null" type="button" class="btn pink smaller" @click="googleform">  
                {{ $t('invest.buy_dfp') }}
              </button>
              <button v-else type="button" class="btn pink smaller" @click="openConnectModal">
                {{ $t('common.connect_wallet') }}
              </button>
              <div v-if="user !== undefined && user !== null" class="btn pink smaller not_active" :tooltip="$t('invest.soon')">
                {{ $t('invest.withdrawal') }}
              </div>
            </div>
          </div>
          <div class="divider"></div>
        </div>
        <div class="action-buttons">
          <button type="button" class="btn pink" @click="scrollToFaq">
            {{ $t('invest.how_to_buy') }}
          </button>
        </div>
      </div>
    </div>
    <div class="levels-area">
      <div class="text-area">
        <div class="subheader">
          {{ $t('invest.level_system') }}
        </div>
        <div class="desc">
          {{ $t('invest.level_system_desc') }}
        </div>
        <div class="levels-list">
          <div class="level-item">
            <div class="list-title">
              {{ $t('invest.token_purchases') }}
            </div>
            <div class="list-content">
              <div class="icon-area">
                <CheckFilled />
              </div>
              <div class="text-area">
                {{ $t('invest.token_purchases_desc') }}
              </div>
            </div>
          </div>
          <div class="level-item">
            <div class="list-title">
              {{ $t('invest.rules') }}
            </div>
            <div class="list-content">
              <div class="icon-area">
                <CheckFilled />
              </div>
              <div class="text-area">
                {{ $t('invest.rules_desc') }}
              </div>
            </div>
          </div>
          <div class="level-item">
            <div class="list-title">
              {{ $t('invest.benefits') }}
            </div>
            <div class="list-content">
              <div class="icon-area">
                <CheckFilled />
              </div>
              <div class="text-area">
                {{ $t('invest.benefits_desc') }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="table-area">
        <div v-if="!levelsLoading && levelsTotal > 0" class="levels-table">
          <div class="level-row th">
            <div class="item">
              {{ $t('invest.levels') }}
            </div>
            <div class="item">
              {{ $t('invest.amount_of_tokens') }}
            </div>
            <div class="item">
              {{ $t('invest.extra_tokens') }}
            </div>
          </div>
          <div v-for="(level, index) in levels" :key="index" class="level-row">
            <div class="item">
              <div class="icon" :style="{background: level.color !== null ? level.color : '#A577CE'}">
                <div class="first-gradient"></div>
                <div class="second-gradient"></div>
              </div>
              <div class="title">
                {{ level.name }}
              </div>
            </div>
            <div class="item">
              {{ $priceFormat(level.from, 0) }} - {{ $priceFormat(level.to, 0) }} DFP
            </div>
            <div class="item">
              {{ $priceFormat(level.discount, 1) }}%
            </div>
          </div>
        </div>
        <div v-else-if="levelsLoading" class="levels-table">
          <div class="level-row th">
            <div class="item">
              {{ $t('invest.levels') }}
            </div>
            <div class="item">
              {{ $t('invest.amount_of_tokens') }}
            </div>
            <div class="item">
              {{ $t('invest.extra_tokens') }}
            </div>
          </div>
          <div v-for="index in 10" :key="index" class="level-row">
            <div class="item">
              <div class="icon">
                <div class="first-gradient"></div>
                <div class="second-gradient"></div>
              </div>
              <div class="title">
                <Skeleton width="100px" height="17px" />
              </div>
            </div>
            <div class="item">
              <Skeleton width="130px" height="17px" />
            </div>
            <div class="item">
              <Skeleton width="30px" height="17px" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="lending-area">
      <div class="transactions-area">
        <div class="chart__area">
          <div class="h2">
            DFP {{ $t('invest.volume_chart') }}
          </div>
          <div v-if="token !== null && token.volume_change !== null && !loadingChart" class="chart__box">
            <LineChart ref="chart" :chart-data="lineChart.data" :options="lineChart.options" />
          </div>
          <div v-else-if="loadingChart" class="chart__box">
            <Loading />
            <div class="h6">
              {{ $t('analytics.loading_chart_data') }}
            </div>
          </div>
          <div v-else class="chart__box">
            <CloudRefreshIcon />
            <div class="h6">
              {{ $t('analytics.no_chart_data') }}
            </div>
          </div>
        </div>
        <div class="h2">
          {{ $t('invest.recent') }}
        </div>
        <div class="filter-row">
          <div class="end-area">
            <div class="sort-area">
              <label for="sortList">
                {{ $t('common.sort_by') }}
              </label>
              <Select v-model="filter.orderField" :options="filterOptions" @select="reloadTransactions" />
            </div>
            <div class="search-area">
              <div class="search-input">
                <Search />
                <input v-model="filter.search" type="text" сlass="input" :placeholder="$t('invest.search_by_hash') + '...'" @input="searchInvestments">
              </div>
            </div>
          </div>
        </div>
        <div v-if="investments.length > 0 && !investmentsLoading" class="transactions-area">
          <div v-for="(transaction, index) in investments" :key="index" class="transaction-item">
            <a :href="transaction.hash" class="transaction-header" rel="nofollow noopener noreferrer" target="_blank">
              <div class="logo">
                <picture>
                  <source srcset="/img/new/floatie-token.webp" type="image/webp">
                  <nuxt-img
                    fit="inside"
                    src="/img/new/floatie-token.png"
                    alt="Buy more DFP tokens to get valuable and exclusive offers from worldwide famous DEX platform"
                    title="Your $DFP token in wallet"
                    loading="lazy"
                    placeholder
                    :quality="80"
                  />
                </picture>
              </div>
              <div class="header-area">
                <p class="desc">
                  {{ transaction.method === 'buy' ? $t('invest.buy') : $t('invest.transfer') }} DFP
                </p>
              </div>
              <div class="regular-item earned no-mobile-border">
                <div class="icon-area">
                  <Coins />
                </div>
                <div class="value-area">
                  <p class="desc">
                    {{ $t('invest.amount') }}
                  </p>
                  <p class="value">
                    {{ $priceFormat(transaction.amount, 2) }}
                  </p>
                </div>
              </div>
              <div class="regular-item apr-area">
                <div class="icon-area">
                  <ChartApr />
                </div>
                <div class="value-area">
                  <p class="desc">
                    {{ $t('invest.price') }} USDT
                  </p>
                  <p class="value">
                    {{ $priceFormat(price, 2) }}
                  </p>
                </div>
              </div>
              <div class="regular-item liquidity-area">
                <div class="icon-area">
                  <Money />
                </div>
                <div class="value-area">
                  <p class="desc">
                    {{ $t('invest.total_price') }}
                  </p>
                  <p class="value">
                    {{ $priceFormat(transaction.price, 2, ) }} USDT
                  </p>
                </div>
              </div>
              <div class="regular-item multiplier-area">
                <div class="value-area">
                  <p class="desc">
                    {{ $t('invest.date') }}
                  </p>
                  <p class="value">
                    {{ $beautifyDate(transaction.created_at) }}
                  </p>
                </div>
              </div>
            </a>
          </div>
        </div>
        <div v-else-if="investmentsLoading" class="transactions-area">
          <div v-for="index in 3" :key="index" class="transaction-item">
            <div class="transaction-header">
              <div class="logo">
                <Skeleton width="50px" height="50px" circle />
              </div>
              <div class="header-area">
                <Skeleton width="75px" height="16px" />
              </div>
              <div class="regular-item earned no-mobile-border">
                <div class="icon-area">
                  <Skeleton width="21px" height="21px" circle />
                </div>
                <div class="value-area">
                  <Skeleton width="45px" height="14px" style="margin-bottom: 0.5rem" />
                  <Skeleton width="35px" height="16px" />
                </div>
              </div>
              <div class="regular-item apr-area">
                <div class="icon-area">
                  <Skeleton width="21px" height="21px" circle />
                </div>
                <div class="value-area">
                  <Skeleton width="45px" height="14px" style="margin-bottom: 0.5rem" />
                  <Skeleton width="35px" height="16px" />
                </div>
              </div>
              <div class="regular-item liquidity-area">
                <div class="icon-area">
                  <Skeleton width="21px" height="21px" circle />
                </div>
                <div class="value-area">
                  <Skeleton width="45px" height="14px" style="margin-bottom: 0.5rem" />
                  <Skeleton width="35px" height="16px" />
                </div>
              </div>
              <div class="regular-item multiplier-area">
                <div class="icon-area">
                  <Skeleton width="21px" height="21px" circle />
                </div>
                <div class="value-area">
                  <Skeleton width="45px" height="14px" style="margin-bottom: 0.5rem" />
                  <Skeleton width="35px" height="16px" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="transactions-area">
          <div class="not-found-area">
            <div class="h3">
              {{ $t('invest.no_transactions') }}
            </div>
          </div>
        </div>
        <div v-if="investments.length > 0" :class="{'pagination-area': true, 'disabled': investmentsLoading}">
          <Pagination :page="filter.page" :step="filter.step" :total="total" @change="setPage" />
        </div>
      </div>
    </div> -->
    <div class="global-hr"></div>
    <div ref="faqHeader" class="h2">
      {{ $t('invest.faqs') }}
    </div>
    <div class="faqs-area">
      <div ref="faq1" class="faq">
        <div class="header-area" @click="toggleFaq(1)">
          <div class="header-text">
            {{ $t('invest.faq_q1') }}
          </div>
          <div class="icon-area">
            <i class="bx bxs-chevron-down"></i>
          </div>
        </div>
        <div class="answer-area">
          <p class="desc">
            {{ $t('invest.faq_a1') }}:
          </p>
          <ul class="list">
            <li class="item">
              {{ $t('invest.faq_a1_1') }}
            </li>
            <li class="item">
              {{ $t('invest.faq_a1_2') }}
            </li>
            <li class="item">
              {{ $t('invest.faq_a1_3') }}
            </li>
            <li class="item">
              {{ $t('invest.faq_a1_4') }}
            </li>
            <li class="item">
              {{ $t('invest.faq_a1_5') }}
            </li>
            <li class="item">
              {{ $t('invest.faq_a1_6') }}
            </li>
            <li class="item">
              {{ $t('invest.faq_a1_7') }}
            </li>
          </ul>
        </div>
      </div>
      <div ref="faq2" class="faq">
        <div class="header-area" @click="toggleFaq(2)">
          <div class="header-text">
            {{ $t('invest.faq_q2') }}
          </div>
          <div class="icon-area">
            <i class="bx bxs-chevron-down"></i>
          </div>
        </div>
        <div class="answer-area">
          <p class="desc">
            {{ $t('invest.faq_a2', { price: price }) }}
          </p>
        </div>
      </div>
      <div v-for="ind in 16" :key="ind" :ref="'faq' + (ind + 2)" class="faq">
        <div class="header-area" @click="toggleFaq(ind + 2)">
          <div class="header-text">
            {{ $t('invest.faq_q' + (ind + 2)) }}
          </div>
          <div class="icon-area">
            <i class="bx bxs-chevron-down"></i>
          </div>
        </div>
        <div class="answer-area">
          <p class="desc">
            {{ $t('invest.faq_a' + (ind + 2)) }}
          </p>
        </div>
      </div>
    </div>
    <div class="cyan-cloud">
      <CloudCyanLiquidityLeft />
    </div>
    <div class="cyan-cloud2">
      <CloudCyanLiquidityRight />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'

import { Skeleton } from 'vue-loading-skeleton'
import {
  hydrateWhenVisible,
  hydrateWhenIdle
} from 'vue-lazy-hydration'

import CloudRefreshIcon from '~/components/svg/new/CloudRefreshIcon'
import InvestToken from '~/components/app/interface/InvestToken'
import LineChart from '~/components/analytics/parts/LineChart'

export default {
  name: 'InvestComponent',
  components: {
    ChartApr: hydrateWhenIdle(() => import('~/components/svg/new/ChartApr')),
    CloudCyanLiquidityLeft: hydrateWhenIdle(() => import('~/components/svg/new/clouds/CloudCyanLiquidityLeft')),
    CloudCyanLiquidityRight: hydrateWhenIdle(() => import('~/components/svg/new/clouds/CloudCyanLiquidityRight')),
    CloudRefreshIcon,
    CheckFilled: hydrateWhenIdle(() => import('~/components/svg/new/CheckFilled')),
    Coins: hydrateWhenIdle(() => import('~/components/svg/new/Coins')),
    InvestToken,
    LineChart,
    Loading: hydrateWhenVisible(() => import('~/components/svg/new/Loading')),
    Money: hydrateWhenIdle(() => import('~/components/svg/new/Money')),
    Search: hydrateWhenIdle(() => import('~/components/svg/new/Search')),
    Select: hydrateWhenIdle(() => import('~/components/app/interface/Select')),
    Skeleton,
    Pagination: hydrateWhenIdle(() => import('~/components/analytics/parts/Pagination')),
    WindowModal: hydrateWhenIdle(() => import('~/components/modals/WindowModal'))
  },
  layout: 'new',
  data() {
    const cookieUser = this.$cookies.get(this.$config.userStorageName)
    const chartColor = cookieUser !== undefined && cookieUser.darkTheme !== undefined && cookieUser.darkTheme === 'on' ? 'rgb(60, 222, 235)' : 'rgb(255, 60, 159)'
    const that = this
    return {
      modalTitle: this.$t('invest.buy_dfp_title'),
      walletConnected: false,
      loading: false,
      error: null,
      method: 'buy',
      price: 0.1,
      totalSupply: 100000000,
      form: {
        from: null,
        to: null,
        hash: null
      },
      filter: {
        page: 1,
        step: 25,
        orderField: 'created_at_desc',
        method: 'all',
        search: ''
      },
      filterOptions: [
        {
          name: this.$t('invest.created_at_desc'),
          value: 'created_at_desc'
        },
        {
          name: this.$t('invest.created_at_asc'),
          value: 'created_at_asc'
        },
        {
          name: this.$t('invest.amount_desc'),
          value: 'amount_desc'
        },
        {
          name: this.$t('invest.amount_asc'),
          value: 'amount_asc'
        }
      ],
      searchTimeout: null,
      timeoutTime: 600,
      loadingChart: false,
      lineChart: {
        data: {
          datasets: [
            {
              borderWidth: 4,
              radius: 0,
              fill: false,
              data: [],
              borderColor: chartColor,
              tension: 0.25,
              pointRadius: 7,
              pointBorderColor: 'rgba(0, 0, 0, 0)',
              pointBackgroundColor: 'rgba(0, 0, 0, 0)',
              pointHoverBackgroundColor: chartColor,
              pointHoverBorderColor: 'rgba(255, 255, 255, 1)'
            }
          ]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          interaction: {
            intersect: false,
            mode: 'index'
          },
          plugins: {
            legend: false
          },
          scales: {
            xAxes: [{
              ticks: {
                autoSkip: true,
                maxRotation: 0,
                minRotation: 0,
                color: 'rgb(var(--main-text-color))',
                callback(value, index, ticks) {
                  return that.$getDateDayAndMonth(value)
                }
              },
              gridLines: {
                color: 'rgba(0, 0, 0, 0)'
              }
            }],
            yAxes: [{
              ticks: {
                autoSkip: true,
                maxRotation: 0,
                minRotation: 0,
                color: 'rgb(var(--main-text-color))',
                callback(value, index, ticks) {
                  return that.$getBigNumber(value)
                }
              },
              gridLines: {
                color: 'rgba(0, 0, 0, 0)'
              }
            }],
            x: {
              type: 'linear'
            },
            weight: 1
          },
          tooltips: {
            enabled: true,
            footerFontStyle: 'normal',
            callbacks: {
              title: (context) => {
                return that.$t('invest.total_volume')
              },
              label: (tooltipItems) => {
                return that.$getBigNumber(tooltipItems.yLabel) + ' DFP'
              },
              labelColor: (context) => {
                return {
                  borderColor: 'rgba(255, 255, 255, 0)',
                  backgroundColor: chartColor,
                  borderWidth: 0,
                  borderRadius: 8
                }
              },
              footer: (context) => {
                return that.$t('invest.dfp_sold') + ' ' + that.$getFormatDate(context[0].xLabel, false)
              }
            }
          }
        }
      }
    }
  },
  async fetch({ store, error, route }) {
    try {
      const pageName = route.name.split('___')
      const seoData = store.getters['seos/seosByUri'](pageName[0])
      if (seoData === null) {
        await store.dispatch('seos/fetchSeos', {
          uri: route.name
        })
      }
    } catch (err) {
      error(err)
    }
  },
  head({ $config: { appUrl } }) {
    return {
      title: this.meta ? this.meta.title : this.$t('common.launching'),
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.meta ? this.meta.description : ''
        },
        {
          hid: 'og-description',
          name: 'og:description',
          content: this.meta ? this.meta.description : ''
        },
        {
          hid: 'og-title',
          name: 'og:title',
          content: this.meta
            ? this.meta.title
            : this.$t('common.launching')
        },
        {
          hid: 'og-image',
          name: 'og:image',
          content: this.meta
            ? this.meta.image
            : appUrl + 'seo/default.jpg'
        },
        {
          hid: 'keywords',
          name: 'keywords',
          content: this.meta ? this.meta.keyword : ''
        }
      ]
    }
  },
  computed: {
    ...mapGetters(['darkTheme']),
    ...mapGetters('auth', [
      'user'
    ]),
    ...mapGetters('investments', [
      'investments',
      'total',
      'investmentsLoading'
    ]),
    ...mapGetters('tokens', [
      'token',
      'tokenLoading'
    ]),
    ...mapGetters('bonus_levels', [
      'levels',
      'levelsLoading'
    ]),
    ...mapGetters('seos', [
      'seosByUri'
    ]),
    ...mapGetters('settings', [
      'settings'
    ]),
    meta() {
      const pageName = this.$nuxt.$route.name.split('___')
      return this.seosByUri(pageName[0])
    },
    volume() {
      return this.available !== null ? (this.totalSupply - this.available) * this.price : 0
    },
    totalPercent() {
      return this.available !== null ? (this.totalSupply - this.available) / this.totalSupply * 100 : 0
    },
    levelsTotal() {
      return this.$store.getters['bonus_levels/total']
    },
    currentLevel() {
      return this.levels.length > 0 && this.user !== null && this.user.dfp_balance !== null ? this.levels.find(itm => itm.from <= this.user.dfp_balance && itm.to >= this.user.dfp_balance) : null
    },
    nextLevel() {
      if (this.user !== null) {
        const currentIndex = this.levels.findIndex(itm => itm.from <= this.user.dfp_balance && itm.to >= this.user.dfp_balance)
        return this.levels.length > 0 && this.user.dfp_balance !== null && this.levels[currentIndex + 1] !== undefined ? this.levels[currentIndex + 1] : null
      } else {
        return null
      }
    },
    tokenLevelPercent() {
      return this.user !== null && this.user.dfp_balance !== null && this.nextLevel !== null ? 100 * this.user.dfp_balance / this.nextLevel.from : 0
    }
  },
  mounted() {
    this.fetchSettings({
      group: 'invest_price'
    }).then(() => {
      this.price = this.settings !== null ? this.settings : 0.1
    })
    this.loadUserData()
    this.loadChartData()
    this.fetchLevels({})
    setTimeout(() => {
      this.fetchCallbackByQuery()
    }, 1000)
  },
  methods: {
    ...mapActions('modal', [
      'changeModalGlobalState',
      'changeModalWalletState'
    ]),
    ...mapActions('tokens', [
      'fetchToken'
    ]),
    ...mapActions('investments', [
      'fetchInvestments'
    ]),
    ...mapActions('bonus_levels', [
      'fetchLevels'
    ]),
    ...mapActions('settings', [
      'fetchSettings'
    ]),
    ...mapMutations('investments', [
      'addInvestment'
    ]),
    openConnectModal() {
      this.changeModalWalletState({
        state: true
      })
    },
    reloadTransactions() {
      this.filter.page = 1
      try {
        this.fetchInvestments(this.filter)
      } catch (err) {
        console.log(err)
      }
    },
    setPage(newPage) {
      this.filter.page = parseInt(newPage, 10)
      try {
        this.fetchInvestments(this.filter)
      } catch (err) {
        console.log(err)
      }
    },
    searchInvestments() {
      clearTimeout(this.searchTimeout)
      this.searchTimeout = setTimeout(() => {
        this.reloadTransactions()
      }, this.timeoutTime)
    },
    loadUserData() {
      if (this.user !== null) {
        this.reloadTransactions()
      }
    },
    openBuyModal() {
      this.method = 'buy'
      this.modalTitle = this.$t('invest.buy_dfp_title')
      this.changeModalGlobalState({
        state: true
      })
    },
    openTransferModal() {
      this.method = 'transfer'
      this.modalTitle = this.$t('invest.transfer_header')
      this.changeModalGlobalState({
        state: true
      })
    },
    closeModal() {
      this.changeModalGlobalState({
        state: false
      })
    },
    showSuccessMessage(formInfo) {
      this.loadUserData()
      this.addInvestment({
        address: null,
        amount: formInfo.from,
        created_at: new Date(),
        hash: null,
        method: 'buy',
        price: formInfo.to
      })
    },
    async loadChartData() {
      this.loadingChart = true
      try {
        await this.fetchToken({
          address: this.$config.investToken
        })
        if (this.token !== null && this.token.volume_change !== null) {
          const chartColor = !this.darkTheme ? 'rgb(60, 222, 235)' : 'rgb(255, 60, 159)'
          const data = JSON.parse(this.token.volume_change)
          const values = []
          const labels = []
          for (const [key, value] of Object.entries(data)) {
            labels.push(key)
            values.push(parseFloat(value))
          }
          this.lineChart.data.labels = labels
          this.lineChart.data.datasets[0].data = values
          this.lineChart.data.datasets[0].borderColor = chartColor
          this.$nuxt.$emit('lineChartUpdate')
        }
        this.loadingChart = false
      } catch (err) {
        this.loadingChart = false
        console.error(err)
      }
    },
    fetchCallbackByQuery() {
      const investSuccess = this.$route.query.invest
      const investError = this.$route.query.no_invest
      if (investSuccess !== undefined && investSuccess !== null) {
        this.$nuxt.$emit('openSuccess', this.$t('invest.operation_successfull'), this.$t('invest.bought_dfp'))
      }
      if (investError !== undefined && investError !== null) {
        this.$nuxt.$emit('openError', this.$t('invest.error_buying'), this.$t('invest.error_buying_desc'))
      }
    },
    toggleFaq(faqId) {
      let faqItem = this.$refs['faq' + faqId]
      if (faqItem !== undefined && Array.isArray(faqItem)) {
        faqItem = faqItem[0]
      }
      if (faqItem !== undefined && faqItem.classList.contains('active')) {
        faqItem.classList.remove('active')
      } else if (faqItem !== undefined) {
        faqItem.classList.add('active')
      }
    },
    scrollToFaq() {
      if (this.$refs.faqHeader !== undefined) {
        this.$refs.faqHeader.scrollIntoView({ behavior: 'smooth' })
      }
    }
  }
}
</script>

<style scoped>
  @import url('~/assets/css/new/invest.css');
  @import url('~/assets/css/new/filter.css');
</style>
